import { useRef } from "react";
import { motion, useMotionValue, animate } from "framer-motion";

const ScreenshotScroll = ({
  src,
  alt,
  windowHeight = 300,
  duration = 5,
}) => {
  const imgRef = useRef(null);
  const animationRef = useRef(null);
  const y = useMotionValue(0);

  const handleEnter = () => {
    const imgHeight = imgRef.current?.offsetHeight ?? 0;
    animationRef.current = animate(y, -(imgHeight - windowHeight), {
      duration,
      ease: "easeInOut",
    });
  };

  const handleLeave = () => {
    if (animationRef.current) animationRef.current.stop();
    animate(y, 0, { duration: 1.5, ease: "easeOut" });
  };

  return (
    <div
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
      style={{
        position: "relative",
        width: "100%",
        height: windowHeight,
        overflow: "hidden",
        cursor: "pointer",
      }}
    >
      <motion.div style={{ y, willChange: "transform" }}>
        <img
          ref={imgRef}
          src={src}
          alt={alt}
          style={{ width: "100%", height: "auto", display: "block" }}
        />
      </motion.div>
    </div>
  );
};

export default ScreenshotScroll;
